import React from "react";
import "./login.scss";
import "../../App.css";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "../../utils/withRouter";
import axios from "axios";

class Logout extends React.Component {

  componentDidMount() {
    localStorage.clear();
    sessionStorage.clear();

    axios
      .get(
        "https://login.microsoftonline.com/{7eb0ebdd-607d-46a7-b651-220d7b418537}/oauth2/v2.0/logout?post_logout_redirect_uri=https://example.com/logout-success"
      )
      .then(() => {
        this.props.history.push("/login");
      })
      .catch((error) => {
        console.error("Error during logout:", error);
      });
  }

  render() {
    return (
      <div className="main-container">
        <Grid container justify="center" alignItems="left" class="singleMidBox">
          <div>Logging out...</div>
          <h3>Thank you!</h3>
        </Grid>
      </div>
    );
  }
}

export default withRouter(Logout);
